import { lazyLoad } from 'utils/loadable';

export const EntityMaterialListPage = lazyLoad(
  () => import('./index'),
  module => module.EntityMaterialListPage
);
